import * as React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { graphql, useStaticQuery } from "gatsby"

const Footer = () => {
  const data = useStaticQuery(graphql`
    query logodata {
      site {
        siteMetadata {
          logos
        }
      }
      allFile {
        edges {
          node {
            childImageSharp {
              id
              gatsbyImageData(
                height: 80
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
              )
            }
            name
          }
        }
      }
    }
  `)

  return (
    <footer className="bg-darkcdfblue p-5 mt-10">
      <p className="text-center font-mono text-orange-50 text-xl">
        With the support of
      </p>
      <div className="container h-30 flex flex-wrap justify-around m-auto items-center">
        {data.site.siteMetadata.logos.map((logo, i) => {
          const image = getImage(
            data.allFile.edges.filter(e => e.node.name === logo)[0].node
              .childImageSharp
          )
          return (
            <div key={i} className="w-12 md:w-40 text-center">
              <GatsbyImage image={image} alt={logo} />
            </div>
          )
        })}
      </div>
      <p className="mt-10 text-center font-mono text-orange-50">
        © 2021 - {new Date().getFullYear()}, Farhi Innovation Lab, Collège de France.
        <br />
        Website by{" "}
        <a
          className="text-orange-300 hover:underline"
          href="https://mayerowitz.io/"
        >
          Antoine Mayerowitz
        </a>
      </p>
    </footer>
  )
}

export default Footer
